package tailwind.color

class UniModalColor(private val colorName: String) : Color {
  override fun toString(): String {
    return colorName
  }
}
